import { render, staticRenderFns } from "./d-lgDetails.vue?vue&type=template&id=38552fcb&"
import script from "./d-lgDetails.vue?vue&type=script&lang=js&"
export * from "./d-lgDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports